
jQuery(document).ready(function ($) {

    // Add class to body when popups is active
    $(document).on('elementor/popup/show', function (event, popupId, popupDocument) {
       $('body').addClass('webien-popup-is-open');
       $('body').addClass('popup-' + popupId + '-open');
    });

    $(document).on('elementor/popup/hide', function (event, popupId, popupDocument) {
        setTimeout(function (){
            $('body').removeClass('webien-popup-is-open');
            $('body').removeClass('popup-' + popupId + '-open');
        }, 50);

    });

});